import { render, staticRenderFns } from "./invite-detail.vue?vue&type=template&id=9bf2b6f8&scoped=true&"
import script from "./invite-detail.vue?vue&type=script&lang=js&"
export * from "./invite-detail.vue?vue&type=script&lang=js&"
import style0 from "./invite-detail.vue?vue&type=style&index=0&id=9bf2b6f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf2b6f8",
  null
  
)

export default component.exports